// extracted by mini-css-extract-plugin
export default {"layout":"_6aa60b3bac _6b8b8848b3 _395ad2c435","h_slide":"aca82321eb","category":"_093e6534ac ba11afe256 _498c464a3f"};